class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._onCloseEnd = null;
    this._closeAnimTimer = null;

    // Close this menu when clicking outside of it
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });

    // When this summary is clicked, close all other open menus
    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', (e) => {
      e.stopPropagation();
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    });
  }

  close() {
    const details = this.mainDetailsToggle;
    if (!details.hasAttribute('open')) return;
    if (details.classList.contains('is-closing')) return;

    const megaContent = details.querySelector('.mega-menu__content');

    if (!megaContent) {
      // Regular dropdown — close immediately
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', false);
      return;
    }

    // Let sticky header react immediately
    if (this.header) this.header.preventHide = false;

    details.classList.add('is-closing');

    const doClose = () => {
      if (megaContent && this._onCloseEnd) {
        megaContent.removeEventListener('transitionend', this._onCloseEnd);
      }
      clearTimeout(this._closeAnimTimer);
      this._onCloseEnd = null;
      this._closeAnimTimer = null;
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        details.querySelector('summary').setAttribute('aria-expanded', false);
      }
      details.classList.remove('is-closing');
    };

    this._onCloseEnd = (e) => {
      if (e.propertyName !== 'opacity') return;
      doClose();
    };

    megaContent.addEventListener('transitionend', this._onCloseEnd);
    // Fallback in case transitionend doesn't fire (e.g. prefers-reduced-motion)
    this._closeAnimTimer = setTimeout(doClose, 400);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
